export default __webpack_public_path__ + "ef51c95f757e32618df697968d3bd707.png";